import React from "react";

import { MenuRounded } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import useAuth from "../../config/context/authContext";
import useMainState from "../../config/context/mainStateContext";
import storageKey from "../../config/storageKey";
import { UtilComponents } from "../../config/util/utilComponents";

import PageHeader from "../../components/PageHeader";
import DevChatConfig from "./components/DevChatConfig";
import NotificationConfig from "./components/NotificationConfig";
import PersonalizationConfig from "./components/PersonalizationConfig";
import SystemConfig from "./components/SystemConfig";
import VersionConfig from "./components/VersionConfig";

export default function SettingsPage() {
  const navigate = useNavigate();

  const { setShowSideMenuDrawer } = useMainState();
  const { currentUserState } = useAuth();

  React.useEffect(() => {}, []);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Configurações"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
        />

        <PersonalizationConfig />

        <NotificationConfig />

        {(UtilComponents.isStaff(currentUserState) ||
          window.localStorage.getItem(storageKey.SHOW_LOG)) && <SystemConfig />}

        <VersionConfig />

        <DevChatConfig />
      </Box>
    </Box>
  );
}
